import axios from 'axios';
import { GET_COMMISSION_BULLETINS, GET_SPECIFIC_COMMISSION_BULLETIN, ADD_COMMISSION_BULLETIN, EDIT_COMMISSION_BULLETIN, DELETE_COMMISSION_BULLETIN, COMMISSION_BULLETINS_LOADING, CLEAR_COMMISSION_BULLETINS, CLEAR_COMMISSION_BULLETIN_CARD } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { ICommission_bulletin, ICommission_history } from '../../types/interfaces';
import store from '../store';

export const getCommission_bulletins = (comId: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: COMMISSION_BULLETINS_LOADING
  });
  axios
    .get('/api/commissionbulletins', {...tokenConfig(getState), params: {comId}})
    .then(res =>
      dispatch({
        type: GET_COMMISSION_BULLETINS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getCommission_bulletinsToPay = (comId: number, societeId: any) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: COMMISSION_BULLETINS_LOADING
  });
  axios
    .get('/api/commissionbulletins/toPay', {...tokenConfig(getState), params: {comId, societeId}})
    .then(res =>
      dispatch({
        type: GET_COMMISSION_BULLETINS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getCommission_bulletinById = (id: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: COMMISSION_BULLETINS_LOADING
  });
  axios
    .get('/api/commissionbulletins/specific', {...tokenConfig(getState), params: {id}})
    .then(res =>
      dispatch({
        type: GET_SPECIFIC_COMMISSION_BULLETIN,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getCommission_bulletinByIdPromise = async (id: number): Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/commissionbulletins/specific', {...tokenConfig(store.getState), params: {id}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getCommission_bulletinByIdPromise", err)
    });
  });
};

export const getCommission_bulletinsByUser = (duration: any, comId: number, projectId: number | "ALL") => (dispatch: Function, getState: Function) => {
  dispatch({
    type: COMMISSION_BULLETINS_LOADING
  });
  axios
    .get('/api/commissionbulletins/byUser', {...tokenConfig(getState), params: {duration, comId, projectId}})
    .then(res =>
      dispatch({
        type: GET_COMMISSION_BULLETINS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const addCommission_bulletin = (accepted: ICommission_history[], rejected: ICommission_history[], comId: number, bonus_malus: number, comment: string, userId: number | undefined, callback: Function, print: boolean) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/commissionbulletins', {accepted, rejected, comId, bonus_malus, comment, userId}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: ADD_COMMISSION_BULLETIN,
        payload: res.data
      })
      callback(res.data, print)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const cancelCommissionBulletin = async (bulletinId: number): Promise<any> => {
  return new Promise((resolve, reject) => {
  axios
    .post('/api/commissionbulletins/cancel', {bulletinId}, tokenConfig(store.getState))
    .then(res =>
      resolve(res)
    )
    .catch(err => {
      reject(err)
    });
  });
};

export const mergeCommissionBulletins = async (bulletinIds: number[]): Promise<any> => {
  return new Promise((resolve, reject) => {
  axios
    .post('/api/commissionbulletins/merge', {bulletinIds}, tokenConfig(store.getState))
    .then(res =>
      resolve(res)
    )
    .catch(err => {
      reject(err)
    });
  });
};

export const deleteCommission_bulletin = (id: number) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/commissionbulletins/${id}`, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: DELETE_COMMISSION_BULLETIN,
        payload: id
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const setCommission_bulletinsLoading = () => {
  return {
    type: COMMISSION_BULLETINS_LOADING
  };
};

export const clearCommission_bulletins = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_COMMISSION_BULLETINS
  })
};

export const clearCardCommission_bulletin = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_COMMISSION_BULLETIN_CARD
  })
};